export function initialize() {

    let triggers = document.querySelectorAll('.accordion__trigger');

    if (!triggers) return;

    triggers.forEach(trigger => {

        trigger.addEventListener('click', () => {
            // If closed, open:
            if (trigger.getAttribute('aria-expanded') === 'false') {
                trigger.setAttribute('aria-expanded', true);
                trigger.nextElementSibling.removeAttribute('inert');
            }
            // If opened, close:
            else {
                trigger.setAttribute('aria-expanded', false);
                trigger.nextElementSibling.setAttribute('inert', '');
            }
        })

    })

}
